"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.trimTrailingSlash = void 0;
exports.trimTrailingSlash = (value) => value.replace(/\/+$/g, "");
//# sourceMappingURL=trim-trailing-slash.js.map